import request from '../../services/request';

const baseUrl = 'https://capnuocthotnot.vn';

export const getVisitors = async () => request.get(`${baseUrl}/api/v1/visitors/get_visitors`).then(res => res.data)

export const updateVisitors = async data => request.post(`${baseUrl}/api/v1/visitors/visit`, data).then(res => res.data);

export default {};
